
// *************************** Import CSS *************************** //

import "./youth-chess-email-list.css";

// ************************************************ Email Contact Form *********************************************************** //

class ContactYouthChessTourn extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `

  <div id="youth-chess-email" class="container">

      <form-popup></form-popup>

    <!-- BEGIN: Title Section -->

    <div class="row">

      <div class="col-12 col-lg-10 mx-auto text-center px-2">
        
        <p class="notified-text font-comic-neue bold bold mx-auto text-center text-size-h1 text-black my-1">
          Get Notified About Our Next Youth Chess Tournament
        </p>

      </div>

    </div>

    <!-- END: Title Section -->

    <form action="" name="submit-to-google-sheet">

      <div class="row col-8 col-md-10 col-lg-8 col-xl-7 mx-auto">

        <div class="col-10 col-md-4 col-lg-3 mb-3 mb-lg-0 mt-lg-1 mx-auto pe-0">
          <input class="form-control me-auto" type="text" id="firstName" name="firstName" placeholder="Enter First Name" aria-label="Enter first name">
        </div>

        <div class="col-10 col-md-4 col-lg-3 mb-3 mb-lg-0 mt-lg-1 mx-auto pe-0">
          <input class="form-control me-auto" type="text" id="lastName" name="lastName" placeholder="Enter Last Name" aria-label="Enter last name">
        </div>

        <div class="col-10 col-md-4 col-lg-4 mb-3 mb-lg-0 mt-lg-1 mx-auto pe-0">
          <input class="form-control me-auto" type="email" id="email" name="email" placeholder="Enter Email Address" aria-label="Enter email address">
        </div>

        <div class="col-10 col-md-12 col-lg-2 text-center mx-auto">
          <button id="submit-email-button" class="email-button" type="submit">Submit</button>
        </div>

      </div>

    </form>

  </div>

    `
  }
}

// *********************** Define 'extends HTMLElements' Above *********************** //

customElements.define('email-contact-youth-chess', ContactYouthChessTourn);

// **************************** Form Popup ************************** //

import '/src/popups/form-popup.js';
import '/src/popups/form-popup.css';

var formPopup = new bootstrap.Modal(document.getElementById('form-popup'));
var formPopupBox = document.getElementById('form-popup-box');
var popupMainText = document.getElementById('popup-main-text');
var popupSubText = document.getElementById('popup-subtext');
var popupCloseButton = document.getElementById('popup-close-btn');
var emailButton = document.getElementById('submit-email-button');

// **************************** Send To Google Sheets ****************************** //

  const scriptURL = 'https://script.google.com/macros/s/AKfycbzFEPFra0w9tR24KguS65LQYo3wpB_uwelOD1sIoIl91fOKeOFMoNZMSYF4Fp3xyBhG/exec'

  const form = document.forms['submit-to-google-sheet'];

  const firstName = document.getElementById('firstName');

  const lastName = document.getElementById('lastName');

  const email = document.getElementById('email');


  popupCloseButton.addEventListener('click', () => {

    formPopup.hide(); // Hide modal using Bootstrap JS method.
  });


  form.addEventListener('submit', e => {
    
    e.preventDefault()

    // console.log('First Name:', firstName.value);

    // console.log('Last Name:', lastName.value);

    // console.log('Email:', email.value);


    if (firstName.value.trim() == null || firstName.value.trim() == '') {
      formPopup.show()
      popupMainText.textContent = "Please enter your first name.";
    
    } else if (lastName.value.trim() == null || lastName.value.trim() == '') {

      formPopup.show()
      popupMainText.textContent = "Please enter your last name.";
    
    } else if (email.value.trim() == null || email.value.trim() == '') {

      formPopup.show()
      popupMainText.textContent = "Please enter your email address.";
    
    } else if (email.value.trim() != null) {

      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email.value.trim())) {

        emailButton.textContent = "Submitting..."

        fetch(scriptURL, { method: 'POST', body: new FormData(form)})
        
        .then(response => {

          form.reset();

          emailButton.textContent = "Submit"

          formPopup.show()
          popupMainText.textContent = "Thank you!";
          popupSubText.textContent = `We will email you when we announce the date for our next youth chess tournament.`;
        })

        .catch(error => console.error('Error!', error.message))
      }

      else { 

          formPopup.show()
          popupMainText.textContent = `Oops!`;
          popupSubText.textContent = `This is not a valid email address. Please re-enter your email address.`;
      }
    }
  })

